import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {IDebounceServiceClient} from "app/common/resources/resources";

@Injectable()
export class DebounceResolver implements Resolve<number> {

  constructor(private iDebounceServiceClient: IDebounceServiceClient) {
  }

  resolve() {
    return this.iDebounceServiceClient.getDebounce();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/filtres/debounce.resolver.ts